import { BASE_URL } from "./connectionUrl";
import Cookies from "js-cookie";

function getToken() {
  const authStaging = Cookies.get("authStaging")
    ? JSON.parse(Cookies.get("authStaging"))
    : null;
  return authStaging?.token || "";
}

/**
 * Step 1 + 2:
 * Get presigned URL → Upload file to S3
 */
export async function s3UploadOCR(file, model, recordId, type, name) {
  const token = getToken();

  // 🔥 important: fallback content type
  const contentType = file.type || "application/pdf";

  // ✅ Step 1: get presigned URL
  const presignedRes = await fetch(
    `${BASE_URL}/api/v1/s3uploads/presigned_url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({
        file_name: file.name,
        content_type: contentType,
        resource_type: model || "GlobalAiContext",
        // The resource type will be determined by the ID—for example:
        // appointment_id → Appointment
        // patient_id → Patient
        ...(type ? { type: String(type) } : {}),
        ...(recordId ? { resource_id: String(recordId) } : {}), // ✅ optional
        ...(name ? { name: String(name) } : {}), // ✅ optional custom name for easier identification in S3
      }),
    },
  );

  if (!presignedRes.ok) {
    throw new Error("Failed to get presigned URL");
  }

  const presignedData = await presignedRes?.json();
  const { url, key, file_url } = presignedData?.payload?.presigned_url;
  const { signed_blob_id } = presignedData?.payload || {};

  if (!url) throw new Error("No presigned URL received");

  // ✅ Step 2: upload to S3
  const uploadRes = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": contentType, // must match Step 1
    },
    body: file,
  });

  if (!uploadRes.ok) {
    const errText = await uploadRes.text(); // 🔥 debug S3 error
    console.error("S3 ERROR:", errText);
    throw new Error("S3 upload failed");
  }
  uploadToS3Confirm(file_url, key, recordId, model, type, signed_blob_id, name);

  return { key, file_url, contentType };
}

/**
 * Fetch previously uploaded OCR files for a resource
 */
export async function getOCRFiles(resourceType, resourceId, type = "ocr_file") {
  const token = getToken();
  const params = new URLSearchParams({ resource_type: resourceType, resource_id: resourceId, type });
  const res = await fetch(`${BASE_URL}/api/v1/s3uploads/resource_files?${params}`, {
    method: "GET",
    headers: { Authorization: `Token ${token}` },
  });
  if (!res.ok) throw new Error("Failed to fetch OCR files");
  const data = await res.json();
  return data?.payload?.files || [];
}

/**
 * Step 3:
 * Confirm upload → save metadata in backend
 */
export async function uploadToS3Confirm(
  file_url,
  key,
  recordId,
  model,
  type,
  signed_blob_id,
  name,
) {
  const token = getToken();

  // ✅ Step 3: confirm API (matches your Postman screenshot)
  const confirmRes = await fetch(`${BASE_URL}/api/v1/s3uploads/confirm`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify({
      // type: "voice",
      // appointment_id: recordId,
      ...(type ? { type: String(type) } : {}),
      ...(name ? { name: String(name) } : {}),
      ...(signed_blob_id ? { signed_blob_id: String(signed_blob_id) } : {}),

      storage_file: {
        resource_type: model || "GlobalAiContext",
        ...(recordId ? { resource_id: Number(recordId) } : {}), // optional
        key: key,
        file_name: file_url.split("/").pop(), // extract filename from URL
        file_url: file_url,
      },
    }),
  });

  if (!confirmRes.ok) {
    const err = await confirmRes.text();
    console.error("CONFIRM ERROR:", err);
    throw new Error("Failed to confirm upload with backend");
  }

  return await confirmRes.json();
}
